export abstract class Builder<TInputData extends object, TOutputData> {
  protected data: TInputData = {} as TInputData;

  public with<TKey extends keyof TInputData>(key: TKey, value: TInputData[TKey]): this {
    this.data[key] = value;
    return this;
  }

  public abstract build(): Promise<TOutputData>;
}
